import React from 'react';
import { Icon } from '@iconify/react';

const STATUS_CONFIGS = {
  approved: {
    label: 'Approved',
    type: 'success',
    icon: 'solar:check-circle-bold'
  },
  verified: {
    label: 'Verified',
    type: 'success',
    icon: 'solar:verified-check-bold'
  },
  active: {
    label: 'Active',
    type: 'success',
    icon: 'solar:check-circle-bold'
  },
  pending: {
    label: 'Pending Review',
    type: 'warning',
    icon: 'solar:clock-circle-bold'
  },
  in_review: {
    label: 'In Review',
    type: 'warning',
    icon: 'solar:clock-circle-bold'
  },
  rejected: {
    label: 'Rejected',
    type: 'danger',
    icon: 'solar:close-circle-bold'
  },
  suspended: {
    label: 'Suspended',
    type: 'danger',
    icon: 'solar:danger-triangle-bold'
  },
  banned: {
    label: 'Banned',
    type: 'danger',
    icon: 'solar:shield-cross-bold'
  },
  inactive: {
    label: 'Inactive',
    type: 'danger',
    icon: 'solar:minus-circle-bold'
  },
  draft: {
    label: 'Draft',
    type: 'neutral',
    icon: 'solar:document-bold'
  }
};

const StatusBadge = ({
  status = 'pending',
  customLabel = null,
  showIcon = true,
  className = ''
}) => {
  const normalizedKey = String(status || '').toLowerCase().trim();
  const config = STATUS_CONFIGS[normalizedKey] || {
    label: customLabel || status,
    type: 'neutral',
    icon: 'solar:info-circle-bold'
  };

  const label = customLabel || config.label;

  return (
    <span 
      className={`hs-status-badge ${config.type} ${className}`}
      role="status"
      aria-label={`Status: ${label}`}
    >
      {showIcon && config.icon && (
        <Icon icon={config.icon} className="text-xs" aria-hidden="true" />
      )}
      <span>{label}</span>
    </span>
  );
};

export default StatusBadge;
